export const dateFormat = "YYYY-MM-DD";
export const dateTimeFormat = `${dateFormat} HH:mm`;
